import "core-js/modules/es.array.map.js";
import React from 'react';
import { Dot, Dots } from './partials';
export var Subsections = function Subsections(_ref) {
  var subsections = _ref.subsections,
    active = _ref.active,
    onSubsectionChange = _ref.onSubsectionChange;
  return React.createElement("div", null, React.createElement("div", null, subsections[active]), React.createElement(Dots, null, subsections.map(function (item, index) {
    return React.createElement(Dot, {
      key: "dot-".concat(index),
      active: index === active,
      onClick: function onClick() {
        return onSubsectionChange(index);
      }
    });
  })));
};